import * as ACTION_TYPES from '../types';

let initialState = {
  documentList: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_DOCUMENTS:
      return { ...state, documentList: action.data };
    case ACTION_TYPES.DELETE_DOCUMENTS:
    let newList = state.documentList.filter(document => document._id !== action.id);
      return {...state, documentList: newList };
    default:
      return state;
  }
};